import { render, staticRenderFns } from "./PatientDetailFeedBack.vue?vue&type=template&id=7898fc82&scoped=true&"
import script from "./PatientDetailFeedBack.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailFeedBack.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailFeedBack.vue?vue&type=style&index=0&id=7898fc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7898fc82",
  null
  
)

export default component.exports